import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Portfolio from './pages/Portfolio';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import ServiceLandingPage from './pages/ServiceLandingPage';
import AdminSubmissions from './pages/AdminSubmissions';
import { Toaster } from './components/ui/toaster';
import './App.css';

const SERVICE_SLUGS = [
  'performance-marketing-consultant',
  'growth-marketing-consultant',
  'paid-media-audit',
  'ga4-gtm-attribution-consultant',
  'server-side-tracking-consultant',
  'conversion-rate-optimization-consultant',
  'ai-marketing-consulting',
  'performance-marketing-consultant-kolkata',
];

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/blog/:slug/" element={<BlogPost />} />
          <Route path="/admin/submissions" element={<AdminSubmissions />} />
          {SERVICE_SLUGS.map((slug) => (
            <React.Fragment key={slug}>
              <Route path={`/${slug}`} element={<ServiceLandingPage />} />
              <Route path={`/${slug}/`} element={<ServiceLandingPage />} />
            </React.Fragment>
          ))}
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
